import { Stack } from "@mui/material";

export type ThemedAdditionalQuestionsForGroupProps = {
  children: React.ReactNode;
};

export const ThemedAdditionalQuestionsForGroup = ({ children }: ThemedAdditionalQuestionsForGroupProps) => {
  return (
    <Stack direction="column" gap={2}>
      {children}
    </Stack>
  );
};
